import { render, staticRenderFns } from "./SelectFont.vue?vue&type=template&id=8e3c1852&scoped=true&"
import script from "./SelectFont.vue?vue&type=script&lang=js&"
export * from "./SelectFont.vue?vue&type=script&lang=js&"
import style0 from "./SelectFont.vue?vue&type=style&index=0&id=8e3c1852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3c1852",
  null
  
)

export default component.exports